import { EpimsBaseEntityDto } from './epim-base.dto';
export class SocialMediaTypeDto extends EpimsBaseEntityDto {

    SocialMediaTypeId: string;

    SocialMediaTypeName: string;

   

}